import React, { PureComponent } from 'react'

import ReactHtmlParser from 'react-html-parser'

import cx from 'classnames'
import styles from './index.scss'
import { dispatchCustomEvent, NavigationEvents } from '@libs/customEvents'
import { openPlace } from '@libs/appUrl'

class PosterName extends PureComponent {
  static defaultProps = {
    className: '',
    posterMid: '',
    target: '_self',
    text: '',
    loc: '',
    locName: '',
    description: '',
  }

  handleOpenPlace =
    ({ loc: loc, target }) =>
    () => {
      if (loc) {
        dispatchCustomEvent(NavigationEvents.ENTER_PLACE, {
          locationId: loc,
          section: this.context.section,
        })
        openPlace({ loc, target })
      }
    }

  render() {
    const {
      className,
      posterMid,
      target,
      text,
      loc,
      locName,
      description,
      onOpenPoster,
      ...etcProps
    } = this.props
    const classNames = cx('poster-name', className, { ellipsis: !!locName || !!description })

    if (!text) return null

    return (
      <div className={classNames} {...etcProps}>
        <style jsx>{styles}</style>
        {text && !posterMid && <span className="name">{ReactHtmlParser(text)}</span>}
        {text && posterMid && (
          <span className="name" onClick={onOpenPoster}>
            {ReactHtmlParser(text)}
          </span>
        )}
        {loc && locName && (
          <span className="loc locName" onClick={this.handleOpenPlace({ loc, target })}>
            {ReactHtmlParser(locName)}
          </span>
        )}
        {description && (
          <span className="description" onClick={onOpenPoster}>
            {ReactHtmlParser(description)}
          </span>
        )}
      </div>
    )
  }
}

export default PosterName
